import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="border-t border-white/5 py-10 px-4 bg-black/50 relative z-10 mt-2" data-id="element-26">
        <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-27">
          <img src="https://i.postimg.cc/7Z06kXm2/Gemini-Generated-Image-e5q1v8e5q1v8e5q1-removebg-preview.png" alt="VISIONGOL" className="h-10 w-auto mb-3 opacity-80" data-id="element-28" />

          <p className="text-gray-400 text-sm font-medium mb-2" data-id="element-29">
            VISIONGOL — Inteligencia Artificial para Análisis Deportivo
          </p>

          <p className="text-gray-600 text-xs mb-6" data-id="element-30">
            © 2026 VISIONGOL. Todos los derechos reservados.
          </p>

          {/* Legal Links */}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-6" data-id="element-31">
            <button onClick={() => setOpenModal('privacy')} className="text-xs text-gray-400 hover:text-brand-blue transition-colors underline-offset-4 hover:underline" data-id="element-32">
              Política de Privacidad
            </button>
            <span className="text-gray-700 text-xs" data-id="element-33">·</span>
            <button onClick={() => setOpenModal('terms')} className="text-xs text-gray-400 hover:text-brand-blue transition-colors underline-offset-4 hover:underline" data-id="element-34">
              Términos y Condiciones
            </button>
          </div>

          <div className="max-w-3xl border-t border-white/5 pt-6" data-id="element-35">
            <p className="text-[11px] text-gray-600 leading-relaxed" data-id="element-36">
              VISIONGOL es una herramienta de análisis deportivo e inteligencia
              predictiva. No garantiza ganancias económicas ni resultados
              específicos en apuestas deportivas. Juega con responsabilidad.
            </p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-37">
        <p className="text-gray-400" data-id="element-38">
          En VISIONGOL valoramos tu privacidad y nos comprometemos a proteger
          tus datos personales. Esta Política de Privacidad describe cómo
          recopilamos, usamos y protegemos la información que nos proporcionas
          al utilizar nuestra plataforma.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-39">
          1. Información que recopilamos
        </h3>
        <p className="text-gray-400" data-id="element-40">
          Recopilamos únicamente la información necesaria para brindarte acceso
          al servicio:
        </p>
        <ul className="list-disc list-inside space-y-1 text-gray-400 ml-2" data-id="element-41">
          <li data-id="element-42">Nombre y dirección de correo electrónico</li>
          <li data-id="element-43">
            Información de pago (procesada de forma segura por proveedores
            externos certificados)
          </li>
          <li data-id="element-44">
            Datos de uso de la plataforma (estadísticas anónimas de navegación)
          </li>
          <li data-id="element-45">Dirección IP y tipo de dispositivo, con fines de seguridad</li>
        </ul>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-46">
          2. Uso de la información
        </h3>
        <p className="text-gray-400" data-id="element-47">
          Utilizamos tus datos exclusivamente para:
        </p>
        <ul className="list-disc list-inside space-y-1 text-gray-400 ml-2" data-id="element-48">
          <li data-id="element-49">
            Brindarte acceso a la plataforma VISIONGOL y sus funcionalidades
          </li>
          <li data-id="element-50">Procesar pagos y gestionar tu suscripción</li>
          <li data-id="element-51">Enviarte actualizaciones relevantes sobre el servicio</li>
          <li data-id="element-52">Mejorar la calidad de los análisis y la experiencia general</li>
          <li data-id="element-53">Cumplir obligaciones legales aplicables</li>
        </ul>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-54">
          3. Protección de datos
        </h3>
        <p className="text-gray-400" data-id="element-55">
          Implementamos medidas técnicas y organizativas para proteger tus datos
          contra accesos no autorizados, pérdida o alteración. Toda la
          información sensible se transmite mediante cifrado SSL.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-56">
          4. Compartición con terceros
        </h3>
        <p className="text-gray-400" data-id="element-57">
          VISIONGOL no vende, alquila ni comparte tus datos personales con
          terceros con fines comerciales. Solo compartimos información con
          proveedores estrictamente necesarios para la operación del servicio
          (procesadores de pago, servicios de email), bajo acuerdos de
          confidencialidad.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-58">
          5. Cookies
        </h3>
        <p className="text-gray-400" data-id="element-59">
          Utilizamos cookies y tecnologías similares para mejorar tu
          experiencia, recordar tus preferencias y analizar el uso de la
          plataforma. Puedes configurar tu navegador para rechazarlas en
          cualquier momento.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-60">
          6. Tus derechos
        </h3>
        <p className="text-gray-400" data-id="element-61">
          Tienes derecho a acceder, rectificar, eliminar u oponerte al
          tratamiento de tus datos en cualquier momento. Para ejercer estos
          derechos, escríbenos a{' '}
          <span className="text-brand-blue" data-id="element-62">soporte@visiongol.com</span>.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-63">
          7. Cambios en esta política
        </h3>
        <p className="text-gray-400" data-id="element-64">
          Podemos actualizar esta Política de Privacidad periódicamente. Te
          notificaremos cualquier cambio significativo a través del correo
          electrónico registrado o mediante un aviso visible en la plataforma.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-65">
          8. Contacto
        </h3>
        <p className="text-gray-400" data-id="element-66">
          Si tienes preguntas sobre esta Política de Privacidad o sobre el
          tratamiento de tus datos, contáctanos en:{' '}
          <span className="text-brand-blue" data-id="element-67">soporte@visiongol.com</span>.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-68">
        <p className="text-gray-400" data-id="element-69">
          Bienvenido a VISIONGOL. Al acceder y utilizar nuestra plataforma,
          aceptas estos Términos y Condiciones en su totalidad. Léelos
          cuidadosamente antes de adquirir el acceso.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-70">
          1. Naturaleza del servicio
        </h3>
        <p className="text-gray-400" data-id="element-71">
          VISIONGOL es una herramienta de análisis deportivo basada en
          inteligencia artificial. Proporciona datos estadísticos, predicciones
          probabilísticas y análisis contextuales con fines informativos y de
          apoyo a la toma de decisiones.{' '}
          <strong className="text-white" data-id="element-72">
            No es un servicio de apuestas, no garantiza resultados específicos y
            no ofrece ganancias económicas aseguradas.
          </strong>
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-73">
          2. Acceso y suscripción
        </h3>
        <p className="text-gray-400" data-id="element-74">
          El acceso a VISIONGOL requiere un pago único o suscripción según el
          plan elegido. Tras completar el pago, recibirás credenciales de acceso
          al terminal privado en tu correo electrónico de forma inmediata.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-75">
          3. Edad mínima
        </h3>
        <p className="text-gray-400" data-id="element-76">
          Debes tener al menos 18 años (o la mayoría de edad legal en tu
          jurisdicción) para utilizar VISIONGOL. Al adquirir el acceso, declaras
          cumplir con este requisito.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-77">
          4. Uso responsable
        </h3>
        <p className="text-gray-400" data-id="element-78">
          VISIONGOL promueve el uso responsable de la información deportiva. El
          usuario reconoce que cualquier decisión de apuesta basada en los
          análisis proporcionados es de su exclusiva responsabilidad. No nos
          hacemos responsables de pérdidas económicas derivadas del uso de
          nuestras predicciones.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-79">
          5. Propiedad intelectual
        </h3>
        <p className="text-gray-400" data-id="element-80">
          Todo el contenido, algoritmos, diseño y materiales de VISIONGOL están
          protegidos por derechos de propiedad intelectual. Queda prohibida la
          reproducción, distribución o reventa del contenido sin autorización
          expresa por escrito.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-81">
          6. Política de reembolso
        </h3>
        <p className="text-gray-400" data-id="element-82">
          Por tratarse de un producto digital de acceso inmediato, los pagos son
          finales una vez completada la entrega del acceso. Casos excepcionales
          (fallos técnicos persistentes, doble facturación) podrán evaluarse
          contactando a soporte dentro de los primeros 7 días.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-83">
          7. Limitación de responsabilidad
        </h3>
        <p className="text-gray-400" data-id="element-84">
          VISIONGOL no garantiza la disponibilidad ininterrumpida del servicio
          ni la exactitud absoluta de las predicciones. La información se
          proporciona "tal cual" y el usuario asume todos los riesgos asociados
          a su uso.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-85">
          8. Cuenta y seguridad
        </h3>
        <p className="text-gray-400" data-id="element-86">
          Eres responsable de mantener la confidencialidad de tus credenciales
          de acceso. No compartas tu cuenta con terceros. Cualquier uso indebido
          o acceso no autorizado debe notificarse de inmediato.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-87">
          9. Modificaciones
        </h3>
        <p className="text-gray-400" data-id="element-88">
          Nos reservamos el derecho de modificar estos Términos en cualquier
          momento. Los cambios entrarán en vigor desde su publicación en esta
          página. El uso continuado del servicio implica aceptación de los
          nuevos términos.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-89">
          10. Legislación aplicable
        </h3>
        <p className="text-gray-400" data-id="element-90">
          Estos Términos se rigen por las leyes aplicables del país de operación
          de VISIONGOL. Cualquier disputa se someterá a la jurisdicción de los
          tribunales competentes correspondientes.
        </p>

        <h3 className="text-white font-display font-bold text-base mt-6 mb-2" data-id="element-91">
          11. Contacto
        </h3>
        <p className="text-gray-400" data-id="element-92">
          Para cualquier consulta sobre estos Términos y Condiciones,
          contáctanos en:{' '}
          <span className="text-brand-blue" data-id="element-93">soporte@visiongol.com</span>.
        </p>
      </LegalModal>
    </>;
}